var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-badge" },
    [
      _c(
        "sup",
        {
          class: [
            `v-badge__${_vm.type}`,
            `v-badge__${_vm.status}`,
            { "v-badge__rt": _vm.position !== "" },
          ],
        },
        [_vm._v(_vm._s(_vm.text))]
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }